import { Button, SideModal } from "shared";
import { ClientsTable } from "./components";
import { CompanyType } from "types/CompanyTypes";
import "./CompanyInfoModal.scss";
import { isDesktop } from "utils";
import { SharesByCompanyType } from "types/SharesTypes";

interface CompanyInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  company: CompanyType | null;
  setAddClient: (company: CompanyType) => void;
  setEditTransaction: (company: SharesByCompanyType) => void;
  isOtherTab?: boolean;
}

const CompanyInfoModal: React.FC<CompanyInfoModalProps> = ({
  isOpen,
  onClose,
  company,
  setAddClient,
  setEditTransaction,
  isOtherTab = false,
}) => {
  return (
    <SideModal
      isOpen={isOpen}
      onClose={onClose}
      title="Lista transakcji"
      subtitle={company?.name}
      className="company-info-modal wide"
    >
      <>
        <Button
          className="button--rounded company-info-modal__button"
          onClick={() => company && setAddClient(company)}
          label="Dodaj transakcję  +"
          styleType={isDesktop() ? undefined : "primary"}
        />
        {isOpen && (
          <ClientsTable
            company={company}
            setEditTransaction={setEditTransaction}
          />
        )}
      </>
    </SideModal>
  );
};

export default CompanyInfoModal;
